(function() {
  function onTidioChatApiReady() {
    window.tidioChatApi.on("close", function() {
     //window.tidioChatApi.hide();
    });
    
  }
  
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  } else {
    document.addEventListener("tidioChat-ready", onTidioChatApiReady);
  }
  
})();